/*eslint-disable */

import VueTelInput from "vue-tel-input";
import appFooter from '../../components/footer/index';
import axios from 'axios';
import { bus } from '../../main';
import countries from './country.json'
import domains from '../../services/domain-list.json';
import { mapGetters } from 'vuex';
import root from '../../_helpers/roots';
import toast from '../../services/toast';
import variation_random_img1 from './../../assets/images/random_img/oddnary-variation-5.jpg';
import variation_random_img2 from './../../assets/images/random_img/oddnary-variation-7.jpg';
import variation_random_img3 from './../../assets/images/random_img/oddnary-variation-1.jpg';
import variation_random_img4 from './../../assets/images/random_img/oddnary-variation-4.jpg';
import variation_random_img5 from './../../assets/images/random_img/oddnary-variation-2.jpg';
import variation_random_img6 from './../../assets/images/random_img/oddnary-variation-6.jpg';
import welcome from '../../components/welcome-popup/index';

var $ = window.jQuery = require('jquery');

// Multi Color Bg Img Of Section

export default {
  name: 'register',
  components: {
    'app-footer': appFooter,
    'welcome-popup': welcome,
    VueTelInput
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      domainLists: [],
      disablebtn: true,
      fname: '',
      lname: '',
      birthdate: '',
      birthMonth: '',
      birthYear: '',
      email: '',
      confirm_email: '',
      country: '',
      //organization: '',
      username: '',
      password: '',
      submitted: false,
      errorMessage: '',
      preloader: true,
      emailInvalidField:false,
      RegisterForm: true,
      RegisterFirstStep: true,
      mobile: '',
      countryList: [],
      phone: {
        number: '',
        country: '',
        isValid: false,
      },
      bindProps: {
        placeholder: "",
        required: true,
        name: "mobile",
        maxLen: 18,
        validCharactersOnly: true,
        wrapperClasses: "custom_mobile_num",
        inputClasses: "form-control",
        disabledFormatting: true,
        autocomplete: 'off',
        dropdownOptions: {
          disabledDialCode: false,
          tabindex: 8
        },
        inputOptions: {
          showDialCode: false,
          tabindex: 9
        },
      },
      price: 0,
      imageIndex:''
    }
  },
  watch: {

  },
  computed: {
    ...mapGetters([
      'isAuthenticated'
    ]),
    emptyFields() {
      this.fname = '',
        this.lname = '',
        this.email = '',
        this.country = '',
        this.birthdate = '',
        this.birthMonth = '',
        this.birthYear = '';
    },
  },
  mounted() {
    this.domainLists = domains;
    // this.getSubscriptionPlan();
    bus.$emit('showHomeMenuBtn', true);
    bus.$emit('showQuizMenubtn', true);
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key],
        value: key
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    // Hide Header Buttons
    bus.$emit('hideHeaderbtn', false);
    bus.$emit('showLoginbtn', true);
    bus.$emit('showRegisterbtn', false);

    this.randomImgLoaded();
    if (this.$store.getters.isAuthenticated) {
      this.$router.push('/profile/')
    }
    jQuery(document).on('keydown', 'input[name="mobile"]', function(event) {
      if (event.keyCode == 32) {
        event.preventDefault();
      }
    });
    if (process.env.NODE_ENV == 'production') {
      this.$scriptLoader.load("https://www.googletagmanager.com/gtag/js?id=UA-152519411-1")
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-152519411-1');
    }
  },
  methods: {
    checkValidDomain() {
      if(this.email != "") {
        let result = false;
        let email = this.email;
        let address = email.split('@').pop();
        address = address.split('.').pop();
        let domain = this.domainLists.filter(item => item === address);
        if(domain && domain.length == 0) {
          result = true;
        }
        return result;
      }
    },
    getSubscriptionPlan() {
      $('.routeloader').css({
        'display': 'flex'
      });
      let mediaListUrlLink = root.signupPlan.link;
      axios.get(mediaListUrlLink).then(response => {
        if (response.status === 200) {
          let plans = response.data.data;
          this.price = plans.filter(plan => plan.validity == 365)[0].price;
          $('.routeloader').hide();
        }
      }).catch(err => {
        console.error(err);
        $('.routeloader').hide();
      })
    },
    onSpace() {},
    countryChange(selectedCountry) {
      this.phone.country = "+" + selectedCountry.dialCode + " ";
    },
    onInput(formattedNumber, {
      number,
      isValid,
      country
    }) {
      this.phone.country = "+" + country.dialCode + " ";
      this.phone.number = number;
      this.phone.isValid = isValid;
      if (this.phone.isValid == true) {
        $('.custom_mobile_num').attr('aria-invalid', 'true')
      } else {
        $('.custom_mobile_num').attr('aria-invalid', 'false')
      }
    },
    inputFocusOut() {
      if ($('.email_change').val() != "") {
        $('.email_change').attr('type', 'password')
      }
    },
    inputFocus() {
      $('.email_change').attr('type', 'text')
    },
    randomImgLoaded() {
      $('.app-loader').show()
      // Multi Color Bg Img Of Section
      var images = ["random_img1", "random_img2", "random_img3", "random_img4", "random_img5", "random_img6"]
      var variation_images = [variation_random_img1, variation_random_img2, variation_random_img3, variation_random_img4, variation_random_img5, variation_random_img6]
      var size = images.length;
      var x = Math.floor(size * Math.random());
      this.imageIndex = x
      var element = document.getElementsByClassName('random_bgimg');
      if (x < images.length) {
        $('.navbar_list_wrp').addClass('act_contest_clr_of_holders' + x);
        element[0].style["background-image"] = "url(" + variation_images[x] + ")"
        this.getUserCountry();
        setTimeout(() => {
          this.preloader = false;
          $('.app-loader').hide()
        }, 1500);
      }
    },
    getUserCountry() {
      var self = this;
      fetch('https://ip2c.org/s')
        .then(function(response) {
          return response.text();
        })
        .then(function(text) {
          if (!text || "1" !== text[0])
            throw new Error("unable to fetch the country");
          self.country = text.substr(2, 2)
        })
        .catch(function(error) {
          log('Request failed', error)
        });
    },
    emailFieldKeyup(){
      this.emailInvalidField = false
    },
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        this.email = this.confirm_email
        if (result && !this.checkValidDomain()) {
          let selectedCountry = this.countryList.filter(item => item.value == this.country);
          if (selectedCountry && selectedCountry.length > 0) {
            selectedCountry = selectedCountry[0].value;
          }
          // let phoneNumber = this.phone.number;
          // phoneNumber = phoneNumber.replace(/\s+/, "_");
          // phoneNumber = phoneNumber.replace(/\s/g, "");
          // phoneNumber = phoneNumber.replace("_", " ");

          // phoneNumber = this.phone.country + phoneNumber;
          let data = {
            first_name: this.fname,
            last_name: this.lname,
            email: this.email,
            password: this.password,
            profile: {
              auto_country: selectedCountry,
              // date_of_birth: this.birthYear + '-' + this.birthMonth + '-' + this.birthdate,
              // mobile: phoneNumber
            }
          }
          this.$store.dispatch('register', data).then((res) => {
              this.preloader = true;
              if (res.data.code == '2002') {
                this.preloader = false;
                toast.success('There are some errors with the data provided.');
                this.$router.push('/login');
              }
            })
            .catch((err) => {
              if(err.data.data.email){
                this.emailInvalidField = true
              }
            })
          return
        }
      });
    },
    registerformFun() {
      this.preloader = true
      this.RegisterForm = true,
      this.RegisterFirstStep = false
      this.randomImgLoaded()
    },
  },
  beforeCreate: function() {
    $('body').addClass('signup public-routes');
    document.title = ' Oddvega - Signup '
  },
  beforeRouteLeave: function(to, from, next) {
    $('.navbar_list_wrp').removeClass('act_contest_clr_of_holders' + this.imageIndex);
    $('body').removeClass('signup public-routes');
    next();
  }
}
